import { useContext } from 'react';
import ParentModelContext from '~/context/new-cars/ParentModelContext';

export default function useEffectiveYear(): number {
  const { customizeOptions, trims, truckBodyStyles } =
    useContext(ParentModelContext);

  const customizedTrim = customizeOptions.data;
  const truckBodyStyleData = truckBodyStyles.data;

  return customizedTrim.year || truckBodyStyleData.year || trims.data.year;
}
